import { EDITOR_INSET_PX } from '@/document-render/presentation/blocks/fields/EditorInsetFrame';

/**
 * Where the block editor canvas draws its chrome, in px relative to a section's top edge. One home
 * for the numbers so the two chrome layers (the Section tab / column switcher and a selected
 * element's name tab / tools / ⋮) cannot be moved into each other again (LLAMS-699: the Section tab
 * covered the first element's drag handle).
 */

/** The selected element's name tab, tools and ⋮ are this tall (`ElementSelectionChrome`, `--size-24`). */
export const ELEMENT_CHROME_HEIGHT_PX = 24;

/** The first row of a section starts this far below the section's top edge (section + element inset). */
export const FIRST_ROW_TOP_PX = EDITOR_INSET_PX.section + EDITOR_INSET_PX.element;

/**
 * How far the chrome of a selected first-row element reaches ABOVE the section's top edge: its tab
 * and ⋮ occupy `[-FIRST_ROW_CHROME_REACH_PX, FIRST_ROW_TOP_PX]` relative to the section.
 */
export const FIRST_ROW_CHROME_REACH_PX = Math.max(0, ELEMENT_CHROME_HEIGHT_PX - FIRST_ROW_TOP_PX);

/**
 * The room the section's own chrome (Section tab, column switcher) leaves below itself. While the
 * selected element is on the section's first row the section chrome is lifted above that element's
 * chrome (Section tab on top, element tab under it); otherwise it sits on the section's edge.
 */
export function sectionChromeClearancePx(selectionOnFirstRow: boolean): number {
  return selectionOnFirstRow ? FIRST_ROW_CHROME_REACH_PX : 0;
}

/** True when `selectedId` is the first element of one of the section's columns. */
export function isSelectionOnFirstRow(
  columns: ReadonlyArray<ReadonlyArray<{ id: string; visible?: boolean }>>,
  selectedId: string | null
): boolean {
  if (selectedId === null) return false;
  return columns.some((column) => column.find((field) => field.visible !== false)?.id === selectedId);
}
